<template>
  <v-card class="mx-auto elevation-0" max-width="auto">
    <v-img v-if="image" :src="image" :aspect-ratio="1.5"></v-img>

    <v-card-title>
      <div>
        <div class="title teal--text mb-3">{{ benefit.name }}</div>

        <div class="body-2 mb-3">
          <template v-if="benefit.start">
            <v-icon class="mr-1 teal--text">date_range</v-icon>
            <span>{{ benefit.start | date }}</span>

            <span v-if="benefit.end && benefit.start!=benefit.end">
              &nbsp;-&nbsp;
              {{ benefit.end | date }}
            </span>

            <br />
          </template>

          <template v-if="benefit.place">
            <v-icon class="mr-1 teal--text">account_balance</v-icon>
            {{ benefit.place.name }}
          </template>
          <template v-else-if="benefit.partner">
            <v-icon class="mr-1 teal--text">account_balance</v-icon>
            {{ benefit.partner.name }}
          </template>
        </div>

        <div v-if="benefit.descriptionShort">
          <!-- <v-divider class="mb-3"></v-divider>
          -->
          <p v-html="benefit.descriptionShort" />
        </div>
      </div>
    </v-card-title>

    <!-- <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn depressed>SZCZEGÓŁY</v-btn>
    </v-card-actions>-->
  </v-card>
</template>

<script>
import { sharedConfig } from '@witkac/kartamiejska-shared';

// @vuese
// Pojedynczy element listy usług
// @group Benefits
export default {
  props: {
    // usługa
    benefit: { required: true }
  },
  computed: {
    image() {
      if (this.benefit.mainImage) {
        return `${process.env.VUE_APP_MEDIA_URL}/${this.benefit.mainImage}?${sharedConfig.sizes.card.small.queryString}`;
      }
      return '/img/no-image.png';
    }
  }
};
</script>
